<template>
  <div>
    <!-- 轮播图 start -->
    <el-carousel class="carousel-box" trigger="click" height="300px">
      <el-carousel-item v-for="(item, index) in carouselItem" :key="index">
        <el-image class="item-bgc" :src="item.bgcIma"></el-image>
        <div class="info-box">
          <p>让商业变得智慧</p>
        </div>
      </el-carousel-item>
    </el-carousel>
    <!-- 轮播图 end -->

    <!-- 企业介绍 start -->
    <div class="content-box-box">
      <div class="content-box">
        <div class="content-box-one">
          <p class="content-p">企业介绍 <span>ABOUT US</span></p>
          <p>
            浙江喔刷信息科技有限公司用自身的热情和真诚为全国中小型企业提供全方位技术支持，助力企业下载和部署软件。
          </p>
          <p>
            经过两年的不断发展，浙江喔刷通过不断的努力，研发出多款可供中小型企业下载使用的软件产品，助力中小企业向智能商业转型升级，用技术驱动商业创新革新，让商业变得更智慧。
          </p>
        </div>

        <div>
          <img src="../assets/imgs/content-1.png" />
        </div>
      </div>

      <div class="content-box p-0">
        <div class="p-10">
          <span class="us-tip">公司理念</span>
          <p class="content-two">简单 自由 平等</p>
        </div>
        <div>
          <img src="../assets/imgs/content-2.png" />
        </div>
        <div class="p-10">
          <span class="us-tip">公司目标</span>
          <p class="content-two">让商业变得更智慧</p>
        </div>
      </div>

      <div class="content-box">
        <div>
          <img src="../assets/imgs/content-3.png" />
        </div>
        <div class="p-10">
          <span class="us-tip">公司使命</span>
          <p class="content-two">助力中小企业向智能商业转型升级</p>
        </div>
        <div>
          <img src="../assets/imgs/content-4.png" />
        </div>
      </div>

      <div>
        <p class="content-foot-p">联系我们</p>
        <div class="content-foot-box">
          <div class="item-box">
            <i class="el-icon-mobile icon-style"></i>
            <p>客服热线</p>
            <p>0579-86399130</p>
          </div>
          <div class="item-box">
            <i class="el-icon-message icon-style"></i>
            <p>邮箱</p>
            <p>guoqingling@payworth.cn</p>
          </div>
          <div class="item-box">
            <i class="el-icon-mobile-phone icon-style"></i>
            <p>手机</p>
            <p>15121056742</p>
          </div>
          <div class="item-box">
            <i class="el-icon-location-information icon-style"></i>
            <p>地址</p>
            <p>浙江省东阳市总部中心A栋西楼1101室喔刷伙伴</p>
          </div>
        </div>
      </div>
    </div>
    <!-- 企业介绍 end -->
  </div>
</template>

<script>
import banner1 from "@/assets/imgs/forusbgc.png";
export default {
  data() {
    return {
      carouselItem: [
        {
          bgcIma: banner1
        }
      ]
    };
  },
  methods: {}
};
</script>

<style scoped>
.carousel-box {
  overflow: hidden;
}
.item-bgc {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
}
.info-box {
  width: 60%;
  height: 50%;
  background-color: transparent;
  position: absolute;
  left: 50%;
  top: 100px;
  transform: translateX(-50%);
  display: flex;
  justify-content: center;
  align-items: center;
}
.info-box p {
  color: #fff;
  font-size: 52px;
}

.content-p {
  font-size: 26px;
  color: rgb(43, 43, 43);
}
.content-box-box {
  padding: 40px 250px;
}
.content-box {
  display: flex;
  justify-content: space-between;
  padding-bottom: 100px;
}
.content-box-one {
  width: 50%;
  color: rgb(169, 169, 169);
  font-size: 14px;
}
.content-p {
  margin-bottom: 50px;
}
.content-p span {
  font-size: 14px;
  color: rgb(222, 222, 222);
}
.content-two {
  font-size: 24px;
  padding-top: 20px;
}
.p-0 {
  padding-bottom: 0;
}
.p-10 {
  padding-top: 30px;
}
.content-foot-p {
  height: 100px;
  text-align: center;
  font-size: 24px;
  font-weight: 600;
}
.content-foot-box {
  display: flex;
  justify-content: space-between;
}
.item-box {
  width: 200px;
  height: 200px;
  border: 1px solid #ebebeb;
  text-align: center;
}
.icon-style {
  color: #00a0e6;
  font-size: 80px;
  padding: 20px 0;
  border-bottom: 1px solid #ccc;
  margin-bottom: 20px;
}
.us-tip {
  color: rgb(75, 75, 75);
  font-size: 14px;
}
</style>



// WEBPACK FOOTER //
// src/components/forus.vue